module.exports = __webpack_public_path__ + "static/media/4.061a4ed8.jpg";